import type {
  MedflexError,
  ModelMedicalDocumentFilterData,
  ModelMedicalDocumentResponse,
} from '@app/api/MedicalDocuments';

import type { BaseOptionType } from 'antd/es/select';
import type dayjs from 'dayjs';

export enum DocumentStatus {
  DRAFT = 'DRAFT',
  PENDING_SIGN = 'PENDING_SIGN',
  SIGNED = 'SIGNED',
  REJECTED = 'REJECTED',
  SENT = 'SENT',
  IN_QUEUE = 'IN_QUEUE',
  SENT_TO_REGISTRY = 'SENT_TO_REGISTRY',
  REGISTERED = 'REGISTERED',
  ERROR = 'ERROR',
}

export const STATUS_LABELS: Record<DocumentStatus, string> = {
  [DocumentStatus.DRAFT]: 'Черновик',
  [DocumentStatus.PENDING_SIGN]: 'Ожидает подписи',
  [DocumentStatus.SIGNED]: 'Подписан',
  [DocumentStatus.REJECTED]: 'Отклонён',
  [DocumentStatus.SENT]: 'Отправлен',
  [DocumentStatus.IN_QUEUE]: 'В очереди',
  [DocumentStatus.SENT_TO_REGISTRY]: 'Отправлен на регистрацию',
  [DocumentStatus.REGISTERED]: 'Зарегистрирован',
  [DocumentStatus.ERROR]: 'Ошибка',
};

const isDocumentStatus = (status: string | null): status is DocumentStatus =>
  status !== null && status in STATUS_LABELS;

export const getDocumentStatusLabel = (status: string | null): string =>
  isDocumentStatus(status) ? STATUS_LABELS[status] : status ?? '';

export const statusColors: Record<DocumentStatus, string> = {
  [DocumentStatus.DRAFT]: 'default',
  [DocumentStatus.PENDING_SIGN]: 'processing',
  [DocumentStatus.SIGNED]: 'success',
  [DocumentStatus.REJECTED]: 'error',
  [DocumentStatus.SENT]: 'warning',
  [DocumentStatus.IN_QUEUE]: 'in_queue',
  [DocumentStatus.SENT_TO_REGISTRY]: 'sent_to_registry',
  [DocumentStatus.REGISTERED]: 'green',
  [DocumentStatus.ERROR]: 'red',
};

export const getDocumentStatusColor = (status: string | null): string =>
  isDocumentStatus(status) ? statusColors[status] : 'default';

export interface FiltersFormValues {
  CreationDateRange?: [dayjs.Dayjs, dayjs.Dayjs];
  DoctorSignedDateRange?: [dayjs.Dayjs, dayjs.Dayjs];
  ChiefSignedDateRange?: [dayjs.Dayjs, dayjs.Dayjs];
}

export interface MedicalCardRegistryFiltersProps {
  filtersData?: ModelMedicalDocumentFilterData;
  isFiltersLoading: boolean;
  selectedStatuses: BaseOptionType[];
  setSelectedStatuses: React.Dispatch<React.SetStateAction<BaseOptionType[]>>;
  selectedDoctors: BaseOptionType[];
  setSelectedDoctors: React.Dispatch<React.SetStateAction<BaseOptionType[]>>;
  submitFormHandler: (values: FiltersFormValues) => Promise<void>;
  handleReset: () => Promise<void>;
}

export interface MedicalDocumentTableItem {
  Id: number;
  DocumentNumber: string;
  PatientName: string;
  ResponsibleDoctorName: string;
  Status: string;
  Kind: number;
  CreationDateTime: string;
  Errors?: MedflexError[] | null;
}

export interface UseMedicalCardRegistryProps {
  setTableData: React.Dispatch<
    React.SetStateAction<ModelMedicalDocumentResponse[]>
  >;
  tableData: ModelMedicalDocumentResponse[];
  setTotalRows: React.Dispatch<React.SetStateAction<number>>;
}
